import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_OCTOPUS_AA_AUGMENTED_SIGN_ASK_CONFIG = defineFcm('octopus_aa_augmented_sign_ask_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				name: { type: 'string', optional: true },
				constraints: {
					type: 'array',
					optional: true,
					shape: { type: 'string' },
				},
				bandit_subject_line_experiment: {
					type: 'object',
					optional: true,
					shape: {
						experiment_name: { type: 'string' },
						constraints: {
							type: 'array',
							shape: { type: 'string' },
						},
					},
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'TBD',
		context: 'comms stack',
		description:
			'Template experiment config for aa_augmented_sign_ask message type. Leave the constraints empty [], to enable the experiment for all countries. Add a bandit_subject_line_experiment object ({ experiment_name, constraints }) to run a bandit subject line experiment (requires comms_stack_subject_line_experimentation_enabled).',
		template: {
			name: '<experiment_name>',
			constraints: ['AR', 'AU', 'BR', 'CA', 'DE', 'ES', 'FR', 'GB', 'ID', 'IN', 'IT', 'JP', 'MX', 'TH', 'TR', 'US'],
		},
	});
